import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = {
  key: 1,
  class: "text-orange-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user.isStaff())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_FieldTextarea, {
            class: "mb-2",
            "model-value": _ctx.modelValue,
            label: _ctx.$t('approval_status_comment'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
          }, null, 8, ["model-value", "label"]),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.APPROVAL_STATUS_DECLINED_REASONS, (reason) => {
              return (_openBlock(), _createBlock(_component_PrimeVueTag, {
                class: "cursor-pointer",
                severity: "info",
                value: reason.title,
                onClick: ($event: any) => (_ctx.applyReason(reason.text))
              }, null, 8, ["value", "onClick"]))
            }), 256))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.modelValue), 1))
  ]))
}